import LijilLakshman from "../assets/images/LijilLakshman.jpg";
import MukeshBubna from "../assets/images/MukeshBubna.jpeg";
import anas from "../assets/images/anas.jpeg";
import kenz from "../assets/images/kenz.jpeg";

export const speakersData = [
    {
        id: 1,
        name: 'Anas Rahman Junaid',
        designation: 'Founder and MD, Hurun India',
        image: anas,
        linkedin: 'https://www.linkedin.com/in/anasrahmanjunaid'
    },
    {
        id: 2,
        name: 'Kenz Milliondots',
        designation: 'Founder, Milliondots Edu',
        image: kenz,
        linkedin: 'https://www.linkedin.com/in/kenzmilliondots'
    },
    {
        id: 3,
        name: 'CA Lijil Lakshman',
        designation: 'Co-Founder and Managing Partner, LDS & Co',
        image: LijilLakshman,
        linkedin: 'https://www.linkedin.com/in/calijillakshman/'
    },
    {
        id: 4,
        name: 'Mukesh Bubna',
        designation: 'Founder & CEO, Monexo',
        image: MukeshBubna,
        linkedin: 'https://www.linkedin.com/in/mukeshbubna'
    },
]